import React from 'react';
import AttributeSelect from './AttributeSelect';

interface Props {
  value: string | '';
  onChange: (id: string | '') => void;
  label?: string;
  className?: string;
}

const DepartmentSelect: React.FC<Props> = ({ value, onChange, label = 'Department', className }) => (
  <AttributeSelect kind="departments" label={label} value={value} onChange={onChange} className={className} />
);

export default DepartmentSelect;
